import styled, { css } from 'styled-components'

export const DropDetailsBanner = styled.section`
  position: relative;
`

const fullAbsolute = css`
  position: absolute;
  width: 100%;
  height: 100%;
`
export const TopGradient = styled.div`
  ${fullAbsolute};
  opacity: 0.4;
  background-image: linear-gradient(to top, #000, rgba(0, 0, 0, 0) 81%);
  top: 0;
`
export const BottomGradient = styled.div`
  ${fullAbsolute};
  opacity: 0.35;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.53),
    rgba(0, 0, 0, 0) 39%,
    rgba(0, 0, 0, 0) 39%
  );
  bottom: 0;
`
